import React from 'react';
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link} from "react-router-dom";
import Typography from "@material-ui/core/Typography";

class AppBreadcrumbs extends React.Component {

    render() {

        const {links, actual} = this.props;

        return (
            <div className='container-breadcrumb'>
                <Breadcrumbs aria-label="breadcrumb" className='breadcrumb'>

                    {links.map((val, index) => {
                        return (
                            <Link key={index} to={`/${val.url}`} color="inherit" variant="body2">
                                {val.label}
                            </Link>
                        );
                    })}

                    <Typography color="textPrimary">{actual}</Typography>
                </Breadcrumbs>
            </div>
        )

    }
}

export default AppBreadcrumbs